import {ApiRes} from '@type/api'
import {apiGet} from '@api/api'
import {ICurrency} from '@type/currency'
import {IApiGetSidebarKeyIdProps} from '@api/user/sidebar/getSidebar'

export const fetchCurrencies = async (props?: IApiGetSidebarKeyIdProps): Promise<ApiRes<ICurrency[]>> => {
    return await apiGet(`currency/all`, {cookies: props?.cookie})
}
